var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Approved"}},[_c('div',{staticClass:"tab-text"},[_c('approved')],1)]),_c('vs-tab',{attrs:{"label":"Applied"}},[_c('div',{staticClass:"tab-text"},[_c('applied')],1)]),_c('vs-tab',{attrs:{"label":"Reversed"}},[_c('div',{staticClass:"tab-text"},[_c('reversed')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }